import React from 'react'
import Svg from './Svg'
export const SvgRequiredStar = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M23.122 16.805l-1.268 2.359a.766.766 0 01-1.177.265l-6.486-3.803v7.517a.798.798 0 01-.855.855h-2.447a.797.797 0 01-.854-.855v-7.517l-6.397 3.803a.767.767 0 01-1.178-.265l-1.269-2.359a.797.797 0 01.324-1.179l6.426-3.625-6.426-3.627a.796.796 0 01-.324-1.178L2.46 4.837a.765.765 0 011.178-.265l6.397 3.891V.857a.797.797 0 01.854-.855h2.535a.796.796 0 01.855.855v7.606l6.398-3.891a.764.764 0 011.177.265l1.268 2.359a.795.795 0 01-.324 1.178l-6.426 3.627 6.426 3.535a.797.797 0 01.324 1.269z" />
  </Svg>
))
SvgRequiredStar.isIcon = true
export default SvgRequiredStar
